<template>
  <div>{{ vatDisclaimerMsg }}</div>
</template>

<script>
export default {
  data() {
    return {
      vatDisclaimerMsg: null,
    };
  },
  props: ['message'],

  watch: {
    message: {
      immediate: true,
      handler() {
        const msg = this.message;
        if (msg === null || msg === '') {
          this.vatDisclaimerMsg = '';
          return;
        }

        const message = msg.toLowerCase().trim();
        if (message === 'nodisclaimer') {
          this.vatDisclaimerMsg = '';
          return;
        }

        const vatIncluded = message.includes('included');
        //1. case percentage exists
        if (msg.includes('-')) {
          const percentage = msg.split('-')[1].trim();

          switch (vatIncluded) {
            case true:
              this.vatDisclaimerMsg = this.$translate('PVATINCLUDED').replace(
                '{percent}',
                percentage
              );
              break;
            case false:
              this.vatDisclaimerMsg = this.$translate('PVATEXCLUDED').replace(
                '{percent}',
                percentage
              );
              break;
          }
        }
        //2. case percentage not existed
        else {
          switch (vatIncluded) {
            case true:
              this.vatDisclaimerMsg = this.$translate('VATINCLUDED');
              break;
            case false:
              this.vatDisclaimerMsg = this.$translate('VATEXCLUDED');
              break;
          }
        }
      },
    },
  },
};
</script>
